import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';
import * as TicketActions from '../../actions/ticket_actions';
// import _ from 'lodash';

let TicketDetails = React.createClass({

    getInitialState() {
        return ({
            ticketData: this.props.ticketData,
            ticketInfo: true,
            history: false,
            ticketsConverstionData: [],
            displayImagSrc: '',
            isModalOpen: false,
            isStatusOptionsOpen: false,
            status: [],
            usertData: [],
            userData: this.props.UserData,
            updateStatus: ''
        });
    },
    componentWillReceiveProps(nextProps) {
        this.setState({ ticketsConverstionData: nextProps.TicketsData.ticketsConverstion });
        this.setState({ usertData: nextProps.UserData });
        if (nextProps.TicketsData && nextProps.TicketsData.status && nextProps.TicketsData.status.status == 200) {
            this.setState({ updateStatus: nextProps.TicketsData.status.data });
        }
    },
    componentWillMount() {
        let data = "/" + this.state.ticketData.id
        this.props.Dispatch(TicketActions.getTicketsConverstion(data));
        this.setState({ updateStatus: (this.props.ticketData.status === 8 ? 'NEW' : (this.props.ticketData.status === 9 ? 'CLOSED' : (this.props.ticketData.status === 10 ? 'REOPEN' : 'IN PROGRESS'))) })
    },

    componentWillUnmount() {
        this.props.Dispatch(TicketActions.changeStatusToNull())
    },

    ticketInfo() {
        this.setState({ ticketInfo: true, history: false });
    },

    history() {
        this.setState({ ticketInfo: false, history: true }, () => {
            document.getElementById('tickect_converstionlist').scrollBy(0, document.getElementById('tickect_converstionlist').offsetHeight);
        });
    },

    getDate(date) {
        if (date) {
            return (new Date(date)).toLocaleString().split(',')[0];
        }
    },


    handleChange(e) {
        let data = "/" + this.state.ticketData.id + "/" + e;
        this.props.Dispatch(TicketActions.getStatus(data));
        this.setState({ isStatusOptionsOpen: false })
    },
    updateMessage(nextProps) {
        let data = {
            "u_id": this.state.userData.loginData.data.id,
            "convo_desc": this.refs.message.value,
            "tkt_id": this.state.ticketData.id,
            "pic": "",
            'uNm': 'Mobi Help'
        };
        if (this.refs.message.value !== '') {
            data['convo_desc'] = this.refs.message.value;
            this.props.Dispatch(TicketActions.getTicketsConverstionReply(data));
            this.refs.message.value = '';
        }

    },

    sendMessage(fromButton, e) {
        if (this.refs.message.value !== '') {
            if (!fromButton) {
                if (e.key === 'Enter') {
                    this.updateMessage();
                    // this.setState({ isSendIconDisabled: true });
                }
            } else {
                // this.setState({ isSendIconDisabled: true });
                this.updateMessage();
            }
        }

    },

    getName(user) {
        if (user) {
            let name = user.firstName ? user.firstName : '';
            name = ' ' + (user.lastName ? user.lastName : '');
            return name !== ' ' ? name : 'Anonymous User';
        } else {
            return 'Anonymous User';
        }
    },
    escalateTicket(ticketId) {
        let data = "/" + `${ticketId}?isEscalated=true`;
        this.props.Dispatch(TicketActions.getStatus(data));
        this.props.onClose();
    },

    render() {

        return (
            <div className='showDetails'>
                <div className='overlay'></div>
                <div className='container'>
                    <div className='header_popup'><h1>Ticket - {this.state.ticketData.guid}</h1><span className='icon-x-circle close' onClick={() => { this.props.onClose() }}><i className='fa fa-times-circle-o' aria-hidden='true'></i></span></div>

                    <div className='selectfield'>
                        <button className={this.state.ticketInfo ? 'toogle_button' : 'active_background'} onClick={() => this.ticketInfo()}>Ticket Info</button>
                        {<button className={this.state.history ? 'toogle_button' : 'active_background'} onClick={() => this.history()}>Support chat</button>}
                        {this.state.ticketData.escalated === true && <button className='t-d escalated' disabled title='can not undo this action'>Escalated</button>}
                        {this.state.ticketData.escalated === false && <button className='t-d escalate' onClick={() => { this.escalateTicket(this.state.ticketData.id) }}>Escalate</button>}
                    </div>
                    {this.state.ticketInfo && <div className='ticket_infochanges'>
                        <div className='ticket_details'>
                            <div className='ticket_id'><span>Ticket GUID : {this.state.ticketData.guid}</span></div>
                            <div className='ticket_statuschange guid-status'>
                                <button className='select_status' onClick={() => { this.setState({ isStatusOptionsOpen: !this.state.isStatusOptionsOpen }); }}>{this.state.updateStatus ? this.state.updateStatus : 'STATUS'}
                                    <span className='icon-dropdown'>
                                        <i className='fa fa-caret-down' aria-hidden='true'></i>
                                    </span></button>
                                {this.state.isStatusOptionsOpen && <div className='status_selection_dropdown'>
                                    <ul className='selected_dropdown_ul'>
                                        <li onClick={() => this.handleChange(8)}>NEW</li>
                                        <li onClick={() => this.handleChange(11)}>IN PROGRESS</li>
                                        <li onClick={() => this.handleChange(10)}>REOPEN</li>
                                        <li onClick={() => this.handleChange(9)}>CLOSED</li>
                                    </ul>
                                </div>
                                }
                            </div>
                        </div>
                        <div className='details_view'>
                            <div className='details_list'>
                                <div className='spanlabel_details'>
                                    <label className='detailscust'>User</label>
                                    <span className='custdetails'>{this.state.ticketData.userName}</span>
                                </div>
                                <div className='spanlabel_details'>
                                    <label className='detailscust'>Created Date</label>
                                    <span className='custdetails'>{this.getDate(this.state.ticketData.cDt)}</span>
                                    <span className='date_error'></span>

                                </div>
                            </div>
                            <div className='details_list'>

                                <div className='spanlabel_details'>
                                    <label className='detailscust'>Status</label>
                                    <span className='custdetails'>{this.state.updateStatus ? this.state.updateStatus : 'STATUS'}</span>
                                </div>
                                <div className='spanlabel_details'>
                                    <label className='detailscust'>Description</label>
                                    <span className='custdetails'>{this.state.ticketData.faultDesc}</span>
                                </div>
                            </div>
                            <div className='details_list'>
                                <div className='spanlabel_details'>
                                    <label className='detailscust'>Device Make</label>
                                    <span className='custdetails'>{this.state.ticketData.deviceMake ? this.state.ticketData.deviceMake : 'N/A'}</span>
                                </div><div className='spanlabel_details'>
                                    <label className='detailscust'>Device Model Number</label>
                                    <span className='custdetails'>{this.state.ticketData.deviceModel ? this.state.ticketData.deviceModel : 'N/A'}</span>
                                </div>
                            </div>
                            <div className='details_list'>
                                <div className='spanlabel_details'>
                                    <label className='detailscust'>Device OS</label>
                                    <span className='custdetails'>{this.state.ticketData.deviceOS ? this.state.ticketData.deviceOS : 'N/A'}</span>
                                </div><div className='spanlabel_details'>
                                    <label className='detailscust'>Device OS Version</label>
                                    <span className='custdetails'>{this.state.ticketData.deviceOSVer ? this.state.ticketData.deviceOSVer : 'N/A'}</span>
                                </div>
                            </div>
                            <div className='details_list'>
                                <div className='spanlabel_details'>
                                    <label className='detailscust'>Application build Version</label>
                                    <span className='custdetails'>{this.state.ticketData.appBuildVer ? this.state.ticketData.appBuildVer : 'N/A'}</span>
                                </div><div className='spanlabel_details'>
                                    <label className='detailscust'>Internet strength </label>
                                    <span className='custdetails'>{this.state.ticketData.internetStr ? this.state.ticketData.internetStr : 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.state.history && <div>
                        <div className='refresh_export' onClick={() => {
                            this.getTicketConverstion(this.props.viewTicketInfo.id);
                            // this.getTicketInfo(this.props.viewTicketInfo.id);
                        }}>
                            {/* <a className=''><span className='icon-shape'></span>Refresh</a> */}
                        </div>
                        <div id='tickect_converstionlist' className='tickect_converstionlist'>
                            <div className='total'>
                                {_.map(this.state.ticketsConverstionData, (data, index) => <div key={data.id}>
                                    <div className='main-block'>
                                        <div className='leftside'>
                                            <span className='date'>{this.getDate(data.cDt)}</span>
                                            {/* <span className='year'></span> */}
                                        </div>
                                        <div className='middle_part'>
                                            <div className='circle'></div>
                                            <div className='line'></div>
                                        </div>
                                        <div className='tickect_converstion'>
                                            <div className='tickect_time'>
                                                <div className='tickect_user'>
                                                    {this.props.UserData.loginData.data.facilities && this.props.UserData.loginData.data.facilities[0].role.name === 'Super Admin' ?
                                                        <span className='customer_support'>{data.ticket && data.ticket.user ? data.ticket.user.guid : 'Anonymous User'}</span> :
                                                        <span className='customer_support'>{data.uNm ? data.uNm : 'Anonymous User'}</span>}
                                                    {/* <span className='customer_status'></span> */}
                                                </div>
                                                <div className='converstion_time'>{(new Date(data.cDt)).toLocaleTimeString()}</div>
                                            </div>
                                            <div className='converstion-mgsdisplay'>
                                                <div className='customer_support'>{data.descrptn}</div>
                                                {/* {data.pic !== '' && <img key={new Date().getTime()} src={data.pic} alt='image loading...' onClick={this.openImage.bind(this)} className='converstion-img' />} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>)}
                            </div>
                        </div>
                        <footer>
                            <div className='footer_background'>
                                <div className='ticket_historyota'>
                                    <input className='sometypemgs' ref='message' placeholder='Type Something' onKeyPress={this.sendMessage.bind(this, false)} />
                                    {/* {this.state.file !== '' && <div className='image_preview'><img src={this.state.file} className='profile_img' />
                                        <span className='icon-x-circle img_close' onClick={() => this.imagepreview()}></span></div>}
                                    <input type='file' name='pic' ref='pic' accept='image/*' onChange={this.fileUpload.bind(this)} className='profile_change' id='upload' />
                                    <label htmlFor='upload' className='profile_changeupload'><img src={require('./../../images/img.png')} alt='add img' /></label> */}
                                </div>
                                {!this.state.isSendIconDisabled && <i className="fa fa-paper-plane mgs_send" aria-hidden="true" onClick={this.sendMessage.bind(this, true)}></i>}
                            </div>
                        </footer>
                        {this.state.isError && <div className='img_error'>*Only text is Allowed</div>}
                    </div>}


                </div>
            </div>
        )
    }
});



let mapStateToProps = (state) => {

    return {

        TicketsData: state.Tickets,
        UserData: state.User,

    };
};
let mapDispatchToProps = (dispatch) => ({
    TicketActions: bindActionCreators(TicketActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TicketDetails));


/** WEBPACK FOOTER **
 ** ./src/components/tickets/ticketDetails.js
 **/